var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "stat-layout-card",
    [
      _c("template", { slot: "title" }, [
        _c("h2", { staticClass: "m-0" }, [_vm._v(_vm._s(_vm.data.title))])
      ]),
      _vm._v(" "),
      _c(
        "template",
        { slot: "content" },
        [
          _vm.mainSlot
            ? _c(
                "div",
                { staticClass: "data-block-number aright" },
                _vm._l(_vm.mainSlot.slots, function(mainSlot, mainSlotIndex) {
                  return _c(
                    "h3",
                    { key: mainSlotIndex, staticClass: "data-value aright" },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            mainSlot.type == "amount"
                              ? _vm.$options.filters.numberformat(
                                  mainSlot.value
                                )
                              : mainSlot.value
                          ) +
                          " " +
                          _vm._s(mainSlot.unit ? mainSlot.unit : "") +
                          "\n            "
                      )
                    ]
                  )
                }),
                0
              )
            : _vm._e(),
          _vm._v(" "),
          _c("h4", { staticClass: "grey ml-2" }, [
            _vm._v(_vm._s(_vm.$l10n.__("Total")))
          ]),
          _vm._v(" "),
          _vm._l(_vm.data.slots, function(stat, statIndex) {
            return stat.name != "total"
              ? _c(
                  "div",
                  { key: statIndex, staticClass: "stats-block stats-inline" },
                  [
                    _c(
                      "a",
                      {
                        staticClass: "primary-50-hover cpointer gray-100",
                        attrs: { href: stat.link, target: "_blank" }
                      },
                      [
                        _c("h3", { staticClass: "stats-title" }, [
                          _vm._v(_vm._s(stat.label))
                        ]),
                        _vm._v(" "),
                        _vm._l(stat.slots, function(value, valueIndex) {
                          return _c(
                            "div",
                            {
                              key: valueIndex,
                              staticClass: "data-block-number inline-block"
                            },
                            [
                              _c("h3", { staticClass: "data-value m-0" }, [
                                _vm._v(
                                  _vm._s(
                                    value.type == "amount"
                                      ? _vm.$options.filters.numberformat(
                                          value.value
                                        )
                                      : value.value
                                  ) +
                                    " " +
                                    _vm._s(value.unit ? value.unit : "")
                                )
                              ])
                            ]
                          )
                        })
                      ],
                      2
                    )
                  ]
                )
              : _vm._e()
          })
        ],
        2
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }